// Tracks a payment whose webhook confirmation is still in-flight.
// Used by PaidRoute to grant a short grace window so users aren't bounced
// back to /payment immediately after a successful checkout.

const KEY = "wekit_pending_payment";
export const PENDING_GRACE_MS = 3 * 60 * 1000; // 3 minutes

export type PendingPayment = {
  orderId: string;
  provider: "razorpay" | "paypal";
  paymentId?: string;
  email?: string;
  startedAt: number;
};

export function setPendingPayment(p: Omit<PendingPayment, "startedAt">) {
  try {
    const payload: PendingPayment = { ...p, startedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function getPendingPayment(): PendingPayment | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingPayment;
    if (!parsed?.startedAt) return null;
    if (Date.now() - parsed.startedAt > PENDING_GRACE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingPayment() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function isPendingPaymentActive(): boolean {
  return !!getPendingPayment();
}
